// routes

export const HOST_API = "https://smartsupervisor.backendapihub.com/api";
